import React, { useContext } from "react";
import { EventGalleryContext } from "./index";
import { OrgDownloadContext } from "../OrganizationPhotos/OrgDownloadContext";
import { Event, Photo } from "./types";
import _ from "lodash";

interface PhotoPricingProps {
  event: Event;
  photo: Photo;
  freeEvent: boolean;
}

const PhotoPricing: React.FC<PhotoPricingProps> = ({
  event,
  photo,
  freeEvent
}) => {
  const {
    cart,
    arePrepaidPhotosAvailable,
    endUserDownloadsDisabled,
    event: contextEvent,
    cookiePrepaidAvailed,
    cookiePrepaidPhotosAvailed
  } = useContext(EventGalleryContext);
  const orgDownloadContext = useContext(OrgDownloadContext);

  const cookieAuthActive =
    contextEvent?.prepaidCustomersPrimaryAuthField === "cookie" &&
    contextEvent.prepaidCustomersEnabled &&
    !cookiePrepaidAvailed &&
    (!contextEvent.prepaidCustomersHardLimitEnabled ||
      ((cart?.prepaidPhotos || []).length + (cookiePrepaidPhotosAvailed || 0)) <
        contextEvent.prepaidCustomersPhotoLimit);

  const isPrepaid =
    cart &&
    (arePrepaidPhotosAvailable || _.includes(cart.prepaidPhotos, photo.id) || cookieAuthActive);

  if (endUserDownloadsDisabled || (freeEvent && orgDownloadContext?.endUserDownloadsDisabled)) {
    return null;
  }

  return (
    <div className="geo-img-leftcont">
      {freeEvent ? (
        <div className="prepaid">
          <span className="free"> Free </span>
          <p>*for High quality digital download</p>
        </div>
      ) : isPrepaid ? (
        <div className="prepaid">
          <span className="prepaid-strike">{contextEvent.displayPrice} </span>
          <span className="currency">{contextEvent.currency}</span>
          <span className="free"> Free </span>
          <p>*for High quality digital download</p>
        </div>
      ) : (
        <>
          <h3>
            <strong>{event.displayPrice}</strong> <span>{event.currency}</span>
          </h3>
          <p>*for High quality digital download</p>
        </>
      )}
    </div>
  );
};

export default PhotoPricing;
